import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import './styles/TagDatePicker.css';

const TagDatePicker = (props) => {
  const [value, setValue] = useState(props.value ? dayjs(props.value) : null);
  const tipText = props.prompt || '';
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;
  const isAlwaysOn = props.isAlwaysOn || false;

  useEffect(() => {
    setValue(props.value ? dayjs(props.value) : null);
  }, [props.value]);

  const isEmpty = !value || (typeof value.isValid === 'function' && !value.isValid());
  const error =
    (validationCase === 'case_4' && props.required && isAlwaysOn && isEmpty) ||
    (validationCase === 'case_2' && props.required && isTagChecked && isEmpty);
  const helperText = error
    ? (validationCase === 'case_4' ? 'This field is required' : 'This field is required if active')
    : '';

  const handleChange = (newValue) => {
    setValue(newValue);
    // Send as local wall-clock YYYY-MM-DD string; toISOString() converts to UTC
    // and the backend echoes the value without a TZ marker, causing date drift
    // across offsets. Matches the YYYY-MM-DD HH:mm format used by other pickers.
    props.onChange({
      name: props.param,
      value: newValue && newValue.isValid?.() ? newValue.format("YYYY-MM-DD") : "",
    });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12}>
        <Tooltip title={tipText} placement="top" arrow>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              fullWidth
              size="small"
              label={props.label}
              value={value}
              onChange={handleChange}
              format="YYYY-MM-DD"
              disabled={props.disabled}
              className="datetime-picker"
              slotProps={{ textField: { error, helperText } }}
            />
          </LocalizationProvider>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagDatePicker;
